module.exports = __webpack_public_path__ + "img/30600.5f2b72ef.jpg";